// Libs
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// Actions
import { GetSharedKitsSettings } from '../actions/sharedKits';

// Hooks
import useFeature from './useFeature';

// Constants
import { FEATURES } from '../constants/features';

const useSharedKitsSettings = () => {
  const dispatch = useDispatch();
  const isEnabled = useFeature(FEATURES.sharedMarketingKits);
  const settings = useSelector((state) => state.sharedKits?.settings);

  useEffect(() => {
    if (isEnabled && !settings) {
      dispatch(GetSharedKitsSettings());
    }
  }, [dispatch, isEnabled, settings]);

  return {
    canCreate: isEnabled && !!settings?.canCreate,
    subgroups: settings?.subgroups || [],
    isSettingsLoaded: !!settings,
  };
};

export default useSharedKitsSettings;
